import { useState, useCallback } from 'react';

const useConfetti = () => {
  const [isActive, setIsActive] = useState(false);

  const triggerConfetti = useCallback(() => {
    setIsActive(true);
  }, []);

  const handleComplete = useCallback(() => {
    setIsActive(false);
  }, []);

  return {
    isActive,
    triggerConfetti,
    handleComplete
  };
};

export default useConfetti;
